import { Button, Heading, ModalDialog, Paragraph } from '@zillow/constellation';
import { PartialMessage } from '@zg-rentals/backend-styled-components';
import type { UserInfoRestrictionsDto } from '@zg-rentals/ts-rental-manager-types';

type Props = {
  restrictions: UserInfoRestrictionsDto;
};

export const BlockedUserModal = ({ restrictions: { partialMessages, title, ctaUrl, ctaText } }: Props) => {
  return (
    <ModalDialog
      renderHeader={
        <Heading as="h1" level={6}>
          Alert
        </Heading>
      }
      renderBody={
        <>
          <Heading fontFamily="serif" marginBottom="sm" level={4} as="h2">
            {title}
          </Heading>

          <Paragraph>
            <PartialMessage partialMessages={partialMessages} />
          </Paragraph>
        </>
      }
      renderFooter={
        <Button as="a" href={ctaUrl} buttonType="primary">
          {ctaText}
        </Button>
      }
      isOpen={true}
      shouldCloseOnESCKeyPress={false}
      shouldCloseOnOutsideClick={false}
      closeButton={null}
      // @ts-ignore
      size={{ default: ModalDialog.SIZES.FULL_SCREEN, md: ModalDialog.SIZES.MD }}
    />
  );
};

export default BlockedUserModal;
